// src/pages/StudentRegistration.js
import React, { useState } from "react";
import { Input, Button, Form, Select, Radio } from "antd";
import axios from "axios";
import { toast } from "react-toastify";
import api from "../utilis/api";
import { useNavigate } from "react-router-dom";

const { TextArea } = Input;

const StudentRegistration = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    skillLevel: "beginner",
    daw: "",
    comment: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSkillLevelChange = (e) => {
    setFormData((prev) => ({ ...prev, skillLevel: e.target.value }));
  };

  const [showMore, setShowMore] = useState(false);

  const text = `
<h4>Stay Protected:</h4>

<p><strong>DOJO’s Off-platform Policy</strong></p>

<p>
Staying on platform with DOJO is essential for creating a positive and safe experience.
Conducting all interactions through DOJO’s communication tools ensures transparency,
supports professionalism, and allows DOJO to assist in any disputes or issues.
</p>

<p>
Use DOJO’s platform exclusively and avoid sharing personal or sensitive details like
passwords or credit card information. Keeping business on DOJO’s platform ensures that
all transactions are safe and can be disputed with urgency.
</p>

<p>
<strong>Report any suspicious activity:</strong> If you encounter anything unusual, report it.
Submit an email and it will go directly to DOJO’s trust and safety team for a thorough review.
</p>

<p>
If someone asks you to move payment or communication outside of DOJO, politely decline.
This will protect your account and keep you financially safe while using DOJO.
</p>

<p>
DOJO is not responsible if students decide to conduct business outside of DOJO and the
transaction is unsafe or made with bad intentions.
</p>
`;
  const shortText = text.slice(0, 200) + "...";
  const handleSignUp = async () => {
    const {
      firstName,
      lastName,
      email,
      phone,
      password,
      confirmPassword,
      skillLevel,
      daw,
      comment,
    } = formData;

    if (
      !firstName ||
      !lastName ||
      !email ||
      !password ||
      !confirmPassword ||
      !skillLevel ||
      !daw
    ) {
      return toast.error("Please fill in all required fields");
    }

    if (password !== confirmPassword) {
      return toast.error("Passwords do not match");
    }

    try {
      const name = `${firstName} ${lastName}`;
      const res = await api.post("/user/register", {
        name,
        email,
        phone,
        password,
        role: "student",
        verificationMethod: "email",
        skillLevel,
        daw,
        comment,
      });
      if (res) {
        toast.success("Student account created successfully!");
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          password: "",
          confirmPassword: "",
          skillLevel: "beginner",
          daw: "",
          comment: "",
        });
        navigate("/", { replace: true });
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <div className="backgroundstudent">
      <div className="main-register">
        <h2
          className="mention-font1"
          style={{
            color: "#e6be5d",
            textAlign: "center",
            marginBottom: "20px",
          }}
        >
          Student Registration
        </h2>
        <Form layout="vertical">
          <Form.Item
            className="mention-font1"
            label={
              <span className="mention-font12" style={{ color: "#fff" }}>
                First Name
              </span>
            }
          >
            <Input
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              placeholder="John"
              style={{ borderRadius: "8px", height: "40px" }}
            />
          </Form.Item>

          <Form.Item
            label={
              <span className="mention-font12" style={{ color: "#fff" }}>
                Last Name
              </span>
            }
          >
            <Input
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              placeholder="Doe"
              style={{ borderRadius: "8px", height: "40px" }}
            />
          </Form.Item>

          <Form.Item
            label={
              <span className="mention-font12" style={{ color: "#fff" }}>
                Email
              </span>
            }
          >
            <Input
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="john@example.com"
              style={{ borderRadius: "8px", height: "40px" }}
            />
          </Form.Item>

          <Form.Item
            label={
              <span className="mention-font12" style={{ color: "#fff" }}>
                Phone
              </span>
            }
          >
            <Input
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="(123) 456-7890"
              style={{ borderRadius: "8px", height: "40px" }}
            />
          </Form.Item>

          <Form.Item
            label={
              <span className="mention-font12" style={{ color: "#fff" }}>
                Password
              </span>
            }
          >
            <Input.Password
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="••••••••"
              style={{ borderRadius: "8px", height: "40px" }}
            />
          </Form.Item>

          <Form.Item
            label={
              <span className="mention-font12" style={{ color: "#fff" }}>
                Confirm Password
              </span>
            }
          >
            <Input.Password
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              placeholder="••••••••"
              style={{ borderRadius: "8px", height: "40px" }}
            />
          </Form.Item>

          {/* Skill Level */}
          <Form.Item
            label={
              <span className="mention-font12" style={{ color: "#fff" }}>
                Skill Level
              </span>
            }
          >
            <Radio.Group
              onChange={handleSkillLevelChange}
              value={formData.skillLevel}
              style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}
            >
              <Radio
                value="beginner"
                className="mention-font12"
                style={{ color: "#fff" }}
              >
                Beginner
              </Radio>
              <Radio
                value="intermediate"
                className="mention-font12"
                style={{ color: "#fff" }}
              >
                Intermediate
              </Radio>
              <Radio
                value="professional"
                className="mention-font12"
                style={{ color: "#fff" }}
              >
                Professional
              </Radio>
            </Radio.Group>
          </Form.Item>

          {/* DAW */}
          <Form.Item
            label={
              <span className="mention-font12" style={{ color: "#fff" }}>
                Which DAW do you use?
              </span>
            }
          >
            <Input
              name="daw"
              value={formData.daw}
              onChange={handleChange}
              placeholder="Ableton, FL Studio, Logic, etc."
              style={{ borderRadius: "8px", height: "40px" }}
            />
          </Form.Item>

          <Form.Item>
            <label
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "8px",
                color: "rgb(250,250,250)", // fixed
                cursor: "pointer",
              }}
            >
              <input
                className="mention-font12"
                type="checkbox"
                required
                style={{
                  cursor: "pointer",
                  transform: "scale(1.3)",
                  marginTop: "3px",
                }}
              />

              <div
                className="mention-font12"
                style={{ marginTop: "-5px", color: "rgb(250,250,250)" }} // fixed
              >
                <p style={{ margin: 0 }}>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: showMore ? text : shortText,
                    }}
                  />

                  <span
                    onClick={(e) => {
                      e.preventDefault(); // prevent checkbox toggle
                      setShowMore(!showMore);
                    }}
                    style={{
                      color: "#007bff",
                      cursor: "pointer",
                      fontSize: "12px",
                      textDecoration: "underline",
                      marginLeft: "4px",
                    }}
                  >
                    {showMore ? " Show Less" : " Show More"}
                  </span>
                </p>
              </div>
            </label>
          </Form.Item>
          {/* Comments */}

          <Button
            className="mention-font12"
            type="primary"
            block
            onClick={handleSignUp}
            style={{
              background:
                "linear-gradient(to right, #fef3c7, #facc15, #fef3c7)",
              border: "none",
              color: "#1f2937",
              fontWeight: "600",
              height: "48px",
              borderRadius: "8px",
            }}
          >
            Register
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default StudentRegistration;
